<template>
  <div>
    <tax-question :value="isUsaResident" text="האם יש לך אזרחות ארה״ב?" @input="emitUsaResident" @observe="observe" />
    <r-separator spaced/>
    <tax-question :value="isPayingUsaTax" text="האם יש לך תושבות ארה״ב לצורכי מס?" @input="emitPayingUsaTax" @observe="observe" />
    <r-separator spaced/>
    <tax-question :value="isOecd" text="האם יש לך תושבות לצורכי מס של מדינה שאינה מדינת ישראל?" @input="emitOecd" @observe="observe" />
  </div>
</template>

<script>
import ValidationObserver from '@/mixins/ValidationObserver';
import RSeparator from '@/components/base/RSeparator';
import TaxQuestion from '@/components/meitav-dash/open-fund/statements/TaxQuestion';
import TaxStateNotSupportedHelper
  from '@/views/meitav-dash/open-fund/dialogs/TaxStateNotSupportedHelper';

export default {
  name: 'Tax',
  components: { TaxQuestion, RSeparator },
  mixins: [ValidationObserver, TaxStateNotSupportedHelper],
  props: {
    isUsaResident: Boolean,
    isPayingUsaTax: Boolean,
    isOecd: Boolean,
  },
  methods: {
    emitUsaResident(input) {
      this.$emit('input:usa-resident', input);
    },
    emitPayingUsaTax(input) {
      this.$emit('input:paying-usa-tax', input);
    },
    emitOecd(input) {
      this.$emit('input:oecd', input);
    },
  },
  watch: {
    shouldShowTaxStateNotSupportedDialog(newValue) {
      if (newValue === true) {
        this.openTaxNotSupportedDialog();
      }
    },
  },
};
</script>
